import { identityService } from '@afterpaytouch/portal-api/identity'
import { useConsumerSelector, useAppSelector, ConsumerAppSelector } from '..'
import { COUNTRY_FIELDS_HIDDEN } from '../../component/IDFlow/DriversLicence/constants'
import { createSelector } from '@reduxjs/toolkit'
import { IdentityState } from './reducer'
import { SessionIdState, SessionIdVisibility } from '../../model'

// Selectors
export const identitySelector: ConsumerAppSelector<IdentityState> = (state) => state.identity

export const biometricOptOutSelector: ConsumerAppSelector<boolean> = createSelector(identitySelector, (state) => state.biometricOptOut)

export const biometricApplicantIdSelector: ConsumerAppSelector<string | undefined> = createSelector(identitySelector, (state) => state.biometricApplicantId)

export const skipBiometricCheckSelector: ConsumerAppSelector<boolean | undefined> = createSelector(identitySelector, (state) => state.skipBiometricCheck)

export const sessionIdSelector: ConsumerAppSelector<SessionIdState> = createSelector(
  identitySelector,
  (state) => state?.sessionId ?? { visibility: SessionIdVisibility.HIDDEN }
)

// Hooks
export const useIdentitySelector = (): IdentityState => useAppSelector(identitySelector)

export const useBiometricOptOut = (): boolean => useAppSelector(biometricOptOutSelector)

export const useBiometricApplicantId = (): string | undefined => useAppSelector(biometricApplicantIdSelector)

export const useSkipBiometricCheck = (): boolean | undefined => useAppSelector(skipBiometricCheckSelector)

export const useSessionId = (): SessionIdState => useAppSelector(sessionIdSelector)

export const useCountryStateIsShown = (): boolean => {
  const { countryCode } = useConsumerSelector()

  const hiddenFields: readonly string[] = COUNTRY_FIELDS_HIDDEN[countryCode as keyof typeof COUNTRY_FIELDS_HIDDEN] ?? []
  return !hiddenFields.includes('state')
}

export const {
  useIdentityVerifyMutation,
  useIdentityPassportMutation,
  useIdentityPassportCountriesQuery,
  useIdentityMedicareMutation,
  useIdentityLicenseMutation,
} = identityService
